/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetCategoriesForReportsDocument = gql`
    query GetCategoriesForReports($branchId: Int!) {
  branchProductCategories(branchId: $branchId) {
    id
    name
    comment
    deleted
    parentCategory {
      id
      name
      deleted
    }
    company {
      id
      name
      address
      phone
      website
      deleted
      bookingQrLink
      isPremiumOn
      paidFeaturesPaginated {
        totalCount
      }
    }
    childCategories {
      id
      name
      deleted
      parentCategory {
        id
        name
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesForReportsQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForReportsQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetCategoriesForReportsQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesForReportsQuery, GetCategoriesForReportsQueryVariables> & ({ variables: GetCategoriesForReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForReportsQuery, GetCategoriesForReportsQueryVariables>(GetCategoriesForReportsDocument, options);
      }
export function useGetCategoriesForReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForReportsQuery, GetCategoriesForReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForReportsQuery, GetCategoriesForReportsQueryVariables>(GetCategoriesForReportsDocument, options);
        }
export function useGetCategoriesForReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesForReportsQuery, GetCategoriesForReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesForReportsQuery, GetCategoriesForReportsQueryVariables>(GetCategoriesForReportsDocument, options);
        }
export type GetCategoriesForReportsQueryHookResult = ReturnType<typeof useGetCategoriesForReportsQuery>;
export type GetCategoriesForReportsLazyQueryHookResult = ReturnType<typeof useGetCategoriesForReportsLazyQuery>;
export type GetCategoriesForReportsSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesForReportsSuspenseQuery>;
export type GetCategoriesForReportsQueryResult = Apollo.QueryResult<GetCategoriesForReportsQuery, GetCategoriesForReportsQueryVariables>;
export const GetProductsBrandsSkUsBarcodesStoragesForReportsDocument = gql`
    query GetProductsBrandsSKUsBarcodesStoragesForReports($companyId: Int!, $branchId: Int!) {
  branchBrands(branchId: $branchId) {
    name
  }
  branchSKUs(branchId: $branchId) {
    name
  }
  branchBarcodes(branchId: $branchId) {
    name
  }
  products(companyId: $companyId, itemsPerPage: 10000, branchId: $branchId) {
    items {
      name
    }
  }
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      branches(id: $branchId) {
        id
        deleted
        storages {
          id
          name
          deleted
          default
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductsBrandsSkUsBarcodesStoragesForReportsQuery__
 *
 * To run a query within a React component, call `useGetProductsBrandsSkUsBarcodesStoragesForReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsBrandsSkUsBarcodesStoragesForReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsBrandsSkUsBarcodesStoragesForReportsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetProductsBrandsSkUsBarcodesStoragesForReportsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsBrandsSkUsBarcodesStoragesForReportsQuery, GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables> & ({ variables: GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsBrandsSkUsBarcodesStoragesForReportsQuery, GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables>(GetProductsBrandsSkUsBarcodesStoragesForReportsDocument, options);
      }
export function useGetProductsBrandsSkUsBarcodesStoragesForReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsBrandsSkUsBarcodesStoragesForReportsQuery, GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsBrandsSkUsBarcodesStoragesForReportsQuery, GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables>(GetProductsBrandsSkUsBarcodesStoragesForReportsDocument, options);
        }
export function useGetProductsBrandsSkUsBarcodesStoragesForReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsBrandsSkUsBarcodesStoragesForReportsQuery, GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsBrandsSkUsBarcodesStoragesForReportsQuery, GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables>(GetProductsBrandsSkUsBarcodesStoragesForReportsDocument, options);
        }
export type GetProductsBrandsSkUsBarcodesStoragesForReportsQueryHookResult = ReturnType<typeof useGetProductsBrandsSkUsBarcodesStoragesForReportsQuery>;
export type GetProductsBrandsSkUsBarcodesStoragesForReportsLazyQueryHookResult = ReturnType<typeof useGetProductsBrandsSkUsBarcodesStoragesForReportsLazyQuery>;
export type GetProductsBrandsSkUsBarcodesStoragesForReportsSuspenseQueryHookResult = ReturnType<typeof useGetProductsBrandsSkUsBarcodesStoragesForReportsSuspenseQuery>;
export type GetProductsBrandsSkUsBarcodesStoragesForReportsQueryResult = Apollo.QueryResult<GetProductsBrandsSkUsBarcodesStoragesForReportsQuery, GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables>;
export const GetStorageReportsDocument = gql`
    query GetStorageReports($startDate: Date!, $endDate: Date!, $reportType: StorageReportType!, $categoryId: Int, $brand: String, $sku_barcode: String, $warehouseId: Int, $filterEmployeeId: Int, $employee: Int!, $page: Int, $itemsPerPage: Int, $branchId: Int!) {
  storageReports(
    startDate: $startDate
    endDate: $endDate
    reportType: $reportType
    categoryId: $categoryId
    brand: $brand
    sku_barcode: $sku_barcode
    warehouseId: $warehouseId
    employeeId: $filterEmployeeId
    employee: $employee
    page: $page
    itemsPerPage: $itemsPerPage
    branchId: $branchId
  ) {
    items {
      totalArrivalQuantity
      totalWriteOffQuantity
      totalMovementQuantity
      totalSaleQuantity
      totalCost
      totalPrice
      totalProfit
      totalAmount
      operations {
        quantity
        cost
        price
        profit
        amount
        type
        date
        warehouse {
          id
          name
          type {
            id
            name
          }
          deleted
          default
        }
        destinationWarehouse {
          id
          name
          deleted
          default
          type {
            id
            name
          }
        }
        employee {
          id
          name
          surname
          email
          phone
          tariffBlocking
          manualBlocking
        }
        operationEmployee {
          id
          name
          surname
        }
      }
      product {
        id
        name
        brand
        sku
        barcode
        productCategoryNew {
          id
          name
          deleted
          parentCategory {
            id
            name
            deleted
          }
        }
        price
        cost
        deleted
      }
    }
    totalCount
    currentPage
    itemsPerPage
    pageCount
  }
}
    `;

/**
 * __useGetStorageReportsQuery__
 *
 * To run a query within a React component, call `useGetStorageReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageReportsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      reportType: // value for 'reportType'
 *      categoryId: // value for 'categoryId'
 *      brand: // value for 'brand'
 *      sku_barcode: // value for 'sku_barcode'
 *      warehouseId: // value for 'warehouseId'
 *      filterEmployeeId: // value for 'filterEmployeeId'
 *      employee: // value for 'employee'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetStorageReportsQuery(baseOptions: Apollo.QueryHookOptions<GetStorageReportsQuery, GetStorageReportsQueryVariables> & ({ variables: GetStorageReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStorageReportsQuery, GetStorageReportsQueryVariables>(GetStorageReportsDocument, options);
      }
export function useGetStorageReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStorageReportsQuery, GetStorageReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStorageReportsQuery, GetStorageReportsQueryVariables>(GetStorageReportsDocument, options);
        }
export function useGetStorageReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageReportsQuery, GetStorageReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStorageReportsQuery, GetStorageReportsQueryVariables>(GetStorageReportsDocument, options);
        }
export type GetStorageReportsQueryHookResult = ReturnType<typeof useGetStorageReportsQuery>;
export type GetStorageReportsLazyQueryHookResult = ReturnType<typeof useGetStorageReportsLazyQuery>;
export type GetStorageReportsSuspenseQueryHookResult = ReturnType<typeof useGetStorageReportsSuspenseQuery>;
export type GetStorageReportsQueryResult = Apollo.QueryResult<GetStorageReportsQuery, GetStorageReportsQueryVariables>;
export const GetCompanyCurrencyForReportPageDocument = gql`
    query GetCompanyCurrencyForReportPage($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      currency {
        code
      }
    }
  }
}
    `;

/**
 * __useGetCompanyCurrencyForReportPageQuery__
 *
 * To run a query within a React component, call `useGetCompanyCurrencyForReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCurrencyForReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyCurrencyForReportPageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyCurrencyForReportPageQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyCurrencyForReportPageQuery, GetCompanyCurrencyForReportPageQueryVariables> & ({ variables: GetCompanyCurrencyForReportPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyCurrencyForReportPageQuery, GetCompanyCurrencyForReportPageQueryVariables>(GetCompanyCurrencyForReportPageDocument, options);
      }
export function useGetCompanyCurrencyForReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyCurrencyForReportPageQuery, GetCompanyCurrencyForReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyCurrencyForReportPageQuery, GetCompanyCurrencyForReportPageQueryVariables>(GetCompanyCurrencyForReportPageDocument, options);
        }
export function useGetCompanyCurrencyForReportPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyCurrencyForReportPageQuery, GetCompanyCurrencyForReportPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyCurrencyForReportPageQuery, GetCompanyCurrencyForReportPageQueryVariables>(GetCompanyCurrencyForReportPageDocument, options);
        }
export type GetCompanyCurrencyForReportPageQueryHookResult = ReturnType<typeof useGetCompanyCurrencyForReportPageQuery>;
export type GetCompanyCurrencyForReportPageLazyQueryHookResult = ReturnType<typeof useGetCompanyCurrencyForReportPageLazyQuery>;
export type GetCompanyCurrencyForReportPageSuspenseQueryHookResult = ReturnType<typeof useGetCompanyCurrencyForReportPageSuspenseQuery>;
export type GetCompanyCurrencyForReportPageQueryResult = Apollo.QueryResult<GetCompanyCurrencyForReportPageQuery, GetCompanyCurrencyForReportPageQueryVariables>;
export const GetEmployeesByBranchIdDocument = gql`
    query GetEmployeesByBranchId($companyId: Int!, $branchId: Int) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        branchEmployees {
          id
          name
          surname
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesByBranchIdQuery__
 *
 * To run a query within a React component, call `useGetEmployeesByBranchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesByBranchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesByBranchIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetEmployeesByBranchIdQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesByBranchIdQuery, GetEmployeesByBranchIdQueryVariables> & ({ variables: GetEmployeesByBranchIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesByBranchIdQuery, GetEmployeesByBranchIdQueryVariables>(GetEmployeesByBranchIdDocument, options);
      }
export function useGetEmployeesByBranchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesByBranchIdQuery, GetEmployeesByBranchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesByBranchIdQuery, GetEmployeesByBranchIdQueryVariables>(GetEmployeesByBranchIdDocument, options);
        }
export function useGetEmployeesByBranchIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesByBranchIdQuery, GetEmployeesByBranchIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesByBranchIdQuery, GetEmployeesByBranchIdQueryVariables>(GetEmployeesByBranchIdDocument, options);
        }
export type GetEmployeesByBranchIdQueryHookResult = ReturnType<typeof useGetEmployeesByBranchIdQuery>;
export type GetEmployeesByBranchIdLazyQueryHookResult = ReturnType<typeof useGetEmployeesByBranchIdLazyQuery>;
export type GetEmployeesByBranchIdSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesByBranchIdSuspenseQuery>;
export type GetEmployeesByBranchIdQueryResult = Apollo.QueryResult<GetEmployeesByBranchIdQuery, GetEmployeesByBranchIdQueryVariables>;
export type GetCategoriesForReportsQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetCategoriesForReportsQuery = { __typename?: 'Query', branchProductCategories?: Array<{ __typename?: 'ProductCategoryNewProxy', id: number, name: string, comment?: string | null, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null, company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, website?: string | null, deleted: boolean, bookingQrLink: string, isPremiumOn: boolean, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', totalCount?: number | null } } | null, childCategories?: Array<{ __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null> | null } | null> | null };

export type GetProductsBrandsSkUsBarcodesStoragesForReportsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetProductsBrandsSkUsBarcodesStoragesForReportsQuery = { __typename?: 'Query', branchBrands: Array<{ __typename?: 'ProductParametersProxy', name: string } | null>, branchSKUs: Array<{ __typename?: 'ProductParametersProxy', name: string } | null>, branchBarcodes: Array<{ __typename?: 'ProductParametersProxy', name: string } | null>, products?: { __typename?: 'ProductPaginated', items?: Array<{ __typename?: 'ProductProxy', name: string }> | null } | null, user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', id: number, deleted: boolean, storages?: Array<{ __typename?: 'StorageProxy', id: number, name: string, deleted: boolean, default: boolean }> | null }> | null } | null } | null };

export type GetStorageReportsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
  reportType: Types.StorageReportType;
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  brand?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sku_barcode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  warehouseId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filterEmployeeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  employee: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetStorageReportsQuery = { __typename?: 'Query', storageReports?: { __typename?: 'StorageReportPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, items?: Array<{ __typename?: 'StorageReportItemProxy', totalArrivalQuantity?: string | null, totalWriteOffQuantity?: string | null, totalMovementQuantity?: string | null, totalSaleQuantity?: string | null, totalCost?: string | null, totalPrice?: string | null, totalProfit?: string | null, totalAmount?: string | null, operations?: Array<{ __typename?: 'StorageReportItemOperationProxy', quantity: string, cost?: string | null, price?: string | null, profit?: string | null, amount?: string | null, type: string, date?: string | null, warehouse?: { __typename?: 'StorageProxy', id: number, name: string, deleted: boolean, default: boolean, type?: { __typename?: 'StorageTypeProxy', id: number, name: string } | null } | null, destinationWarehouse?: { __typename?: 'StorageProxy', id: number, name: string, deleted: boolean, default: boolean, type?: { __typename?: 'StorageTypeProxy', id: number, name: string } | null } | null, employee?: { __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null, email: string, phone: string, tariffBlocking: boolean, manualBlocking: boolean } | null, operationEmployee?: { __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null } | null }> | null, product?: { __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null, barcode?: string | null, price: string, cost?: string | null, deleted: boolean, productCategoryNew?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null } | null }> | null } | null };

export type GetCompanyCurrencyForReportPageQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetCompanyCurrencyForReportPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', currency?: { __typename?: 'CurrencyProxy', code?: string | null } | null } | null } | null };

export type GetEmployeesByBranchIdQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetEmployeesByBranchIdQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', branchEmployees?: Array<{ __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null }> | null }> | null } | null } | null };
